// import "./main.scss";
import Head from "../../elements/head/head";
import Footer from "../../elements/footer/footer";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import BannerApp from "../../elements/banner/Banner";
import LentaCardApp from "../../elements/lenta_card/Lenta_card";
import { useEffect, useState, useRef } from "react";
import api from "../../api";
import { useSelector } from "react-redux";
import Pagination from "@mui/material/Pagination";
import Progress from "../../elements/progress/progress";
import Grid from "@mui/material/Grid";
import LeftSideBarApp from "../../elements/left_side_bar/Left_side_bar";
import { useDispatch } from "react-redux";

const SideBar = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.color.main,
  padding: theme.spacing(0),
  textAlign: "center",
  color: theme.color.secondary,
}));

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(0),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const Main = (args) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const search = useSelector((state) => state.searchSelector.search);
  const countRef = useRef(0);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(0);
  const handleChange = (event, value) => {
    setPage(value);
  };

  const getNewsFunc = () => {
    setLoading(true);
    api.getNews(search, page).then((response) => {
      console.log(search);
      setData(response.data.news);
      setPages(response.data.pages);
    });

    setLoading(false);
  };

  useEffect(() => {
    getNewsFunc(search);
  }, [search, page]);

  return loading ? (
    <Progress load={loading} />
  ) : (
    <Grid container spacing={2}>
      <Grid size={12}>
        <Head />
      </Grid>

      <Grid container size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
        <Grid
          sx={{
            display: {
              xs: "none",
              sm: "none",
              md: "block",
              lg: "block",
              xl: "block",
            },
          }}
          size={{ lg: 1, xl: 1 }}
        ></Grid>
        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 10, xl: 10 }}>
          <BannerApp />
        </Grid>

        <Grid
          sx={{
            display: {
              xs: "none",
              sm: "none",
              md: "block",
              lg: "block",
              xl: "block",
            },
          }}
          size={{ lg: 1, xl: 1 }}
        ></Grid>
      </Grid>

      <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} container>
        <Grid
          sx={{
            display: {
              xs: "none",
              sm: "none",
              md: "block",
              lg: "block",
              xl: "block",
            },
          }}
          size={{ lg: 1, xl: 1 }}
        ></Grid>
        <Grid
          sx={{
            display: {
              xs: "none",
              sm: "none",
              md: "none",
              lg: "block",
              xl: "block",
            },
          }}
          size={{ md: 2, lg: 2, xl: 2 }}
        >
          <SideBar>
            <LeftSideBarApp />
          </SideBar>
        </Grid>
        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 8, xl: 8 }}>
          {data.length != 0 ? (
            data.map((e) => <LentaCardApp e={e} ref={countRef} />)
          ) : (
            <Paper>
              <h3>
                {" "}
                Вас приветствует Рязанская Федерация пауэрлифтинга! Тут пока нет
                ни одной новости, скоро появится контент!
              </h3>
            </Paper>
          )}
          <Item>
            <Pagination count={pages} page={page} onChange={handleChange} />
          </Item>
        </Grid>
      </Grid>
      <Grid
        sx={{
          display: {
            xs: "none",
            sm: "none",
            md: "block",
            lg: "block",
            xl: "block",
          },
        }}
        size={{ lg: 1, xl: 1 }}
      ></Grid>

      <Grid size={12}>
        <Footer />
      </Grid>
    </Grid>
  );
};

export default Main;
